
import React from "react";

export const YearDropDown = ({ selectedyear, onChange }) => {
  selectedyear = selectedyear === "" ? new Date().getFullYear() : selectedyear

  const years = (() => {
    let year = parseInt(process.env.REACT_APP_START_YEAR);
    let yearsarr = Array.from(new Array(20), (val, index) => index + year);
    return yearsarr.map((i) => {
      return (
        <option key={i} value={i}>
          {i}
        </option>
      )
    })
  })

  return (
    <div align="right" style={{ align: "right", border: "none" }}>
      <select
        required
        value={selectedyear}
        style={{ width: "9vw", align: "right", height: "32px", borderColor: "var(--col-ddd)", borderRadius: "3px" }}
        onChange={(opt) => {
          onChange(opt.target);
        }}
      >
        {years()}
      </select>
    </div>
  )
}